import { render, staticRenderFns } from "./VCol.vue?vue&type=template&id=3937934c&scoped=true&"
import script from "./VCol.vue?vue&type=script&lang=js&"
export * from "./VCol.vue?vue&type=script&lang=js&"
import style0 from "./VCol.vue?vue&type=style&index=0&id=3937934c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3937934c",
  null
  
)

export default component.exports